import SpriteSymbol from "../../../../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "heart-open",
  "use": "heart-open-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"heart-open\"><path fill=\"var(--bolt-theme-icon, currentColor)\" d=\"M16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.9-3.1 5.7-7.9 10.1H12l-.1-.1C6.9 14 3.7 11.1 4 8c.1-.7.4-1.4.9-1.9 1.6-1.7 4.2-1.3 5.6.3l1.2 1.4c.2.2.5.2.7 0l1.2-1.4c.7-.9 1.8-1.4 2.9-1.4m0-2A6 6 0 0012 5.1 6 6 0 007.5 3 5.4 5.4 0 002 8.5c0 3.8 3.4 6.9 8.6 11.5l1.4 1.3 1.4-1.3c5.1-4.7 8.6-7.8 8.6-11.5C22 5.4 19.6 3 16.5 3z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol